import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import AppLayout from "../components/AppLayout";
import MatchCard from "../components/MatchCard";
import SportIcon from "../components/SportIcon";
import { api } from "../lib/api";
import { useI18n } from "../contexts/I18nContext";
import { useAuth } from "../contexts/AuthContext";

export default function Matches() {
  const { t } = useI18n();
  const { user } = useAuth();
  const [sports, setSports] = useState([]);
  const [matches, setMatches] = useState([]);
  const [filter, setFilter] = useState(null);
  const [mine, setMine] = useState(false);

  useEffect(() => { api.get("/sports").then((r) => setSports(r.data)); }, []);
  useEffect(() => {
    const params = [];
    if (filter) params.push(`sport_id=${filter}`);
    if (mine) params.push("mine=true");
    const qs = params.length ? `?${params.join("&")}` : "";
    api.get(`/matches${qs}`).then((r) => setMatches(r.data));
  }, [filter, mine]);

  return (
    <AppLayout>
      <div className="flex items-end justify-between flex-wrap gap-4">
        <div>
          <h1 className="font-heading text-3xl sm:text-4xl font-black">{t("matches")}</h1>
          <p className="text-zinc-400 mt-2">{t("play_now_subtitle")}</p>
        </div>
        <div className="flex items-center gap-2">
          {user && (
            <div className="inline-flex rounded-xl bg-zinc-900 border border-zinc-800 p-1" data-testid="matches-mine-toggle">
              <button data-testid="matches-tab-all" onClick={() => setMine(false)} className={`px-3 py-2 rounded-lg text-sm ${!mine ? "bg-zinc-800 text-white" : "text-zinc-400 hover:text-white"}`}>All</button>
              <button data-testid="matches-tab-mine" onClick={() => setMine(true)} className={`px-3 py-2 rounded-lg text-sm ${mine ? "bg-zinc-800 text-white" : "text-zinc-400 hover:text-white"}`}>My events</button>
            </div>
          )}
          {user && (
            <Link to="/matches/create" data-testid="matches-create" className="pp-btn-primary px-5 py-3 rounded-xl flex items-center gap-2">
              <Plus size={18} /> {t("create_match")}
            </Link>
          )}
        </div>
      </div>
      <div className="mt-6 flex flex-wrap gap-2">
        <button data-testid="match-filter-all" onClick={() => setFilter(null)} className={`pp-chip ${filter === null ? "pp-chip-active" : ""}`}>All</button>
        {sports.map((s) => (
          <button key={s.id} data-testid={`match-filter-${s.slug}`} onClick={() => setFilter(s.id)} className={`pp-chip ${filter === s.id ? "pp-chip-active" : ""}`}>
            <SportIcon slug={s.slug} size={14} /> {s.name}
          </button>
        ))}
      </div>
      {matches.length === 0 ? (
        <div className="pp-card p-12 mt-8 text-center text-zinc-500" data-testid="matches-empty">{mine ? "You haven't created any matches yet." : t("no_results")}</div>
      ) : (
        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="matches-grid">
          {matches.map((m) => <MatchCard key={m.id} match={m} />)}
        </div>
      )}
    </AppLayout>
  );
}
